import * as actionTypes from './actionTypes';

interface State {
  dataPOST: any;
  isFetchingPOST: boolean;
  errorPOST: boolean;
}

const initialState: State = {
  isFetchingPOST: false,
  errorPOST: false,
  dataPOST: {}
}

export const autentication = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.ACTIVE_ACCOUNT_REQUEST:
      return {
        ...state,
        isFetchingPOST: true
      }
    case actionTypes.ACTIVE_ACCOUNT_FAILURE:
      return {
        ...state,
        isFetchingPOST: false,
        errorPOST: true
      }
    case actionTypes.ACTIVE_ACCOUNT_SUCCESS:
      return {
        ...state,
        isFetchingPOST: false,
        errorPOST: false,
        dataPOST: action.data
      }
    default:
      return state;
  }
}
